import { createSlice } from "@reduxjs/toolkit";
import { ToastInterfaceData } from "../dto/toast.dto";

const defaultValue: ToastInterfaceData = {
    dialogBgColor: "",
    showDialog: false,
    dialogMsg: "",
    timer: "",
};

export const toastSlice = createSlice({
    name: "toastSlice",
    initialState: defaultValue,
    reducers: {
        showToaster: (state, action) => {
            let newValueState = { ...state };
            newValueState.dialogBgColor =
                action.payload && action.payload.dialogBgColor
                    ? action.payload.dialogBgColor
                    : "";
            newValueState.dialogMsg =
                action.payload && action.payload.dialogMsg
                    ? action.payload.dialogMsg
                    : "";
            newValueState.timer =
                action.payload && action.payload.timer
                    ? action.payload.timer
                    : "";
            newValueState.showDialog =
                action.payload && action.payload.showDialog
                    ? action.payload.showDialog
                    : false;
            return newValueState;
        },
        hideToaster: (state) => {
            let newValueState = { ...state };
            newValueState.dialogBgColor = "";
            newValueState.dialogMsg = "";
            newValueState.timer = "";
            newValueState.showDialog = false;
            return newValueState;
        },
    },
});
export const { showToaster, hideToaster } = toastSlice.actions;
export default toastSlice.reducer;
